import React from 'react'
import TableHeadRowCenter from '../../components/TableComponents/TableHeadRowCenter'
import TableBodyRowCenter from '../../components/TableComponents/TableBodyRowCenter'
import { Button } from 'react-bootstrap'
import { format, addHours } from 'date-fns'
import TableHeadRowStart from '../../components/TableComponents/TableHeadRowStart'
import TableBodyRowStart from '../../components/TableComponents/TableBodyRowStart'

const TableData = ({ array, editFunction, deleteFunction }) => {
  return (
    <>
      <thead>
        <tr>
          {/* <TableHeadRowCenter text='Ativo' /> */}
          <TableHeadRowCenter text='Código' />
          <TableHeadRowCenter text='Progresso' />
          <TableHeadRowCenter text='Data' />
          <TableHeadRowStart text='Título' />
          <TableHeadRowStart text='Paciente' />
          <TableHeadRowStart text='Doutor' />
          <TableHeadRowCenter text='Ações' />
        </tr>
      </thead>

      <tbody >
        {array?.map((cliente, index) => {
          return (
            <tr key={cliente.codigo} className='trBody'>
              {/* <TableBodyRowCenter text={cliente.ativo === true ? <FaCheck /> : <FaX />} alt='Ativo' /> */}
              <TableBodyRowCenter text={cliente.codigo} menor={true} />
              <TableBodyRowCenter text={cliente.progresso} menor={true} />
              <TableBodyRowCenter text={format(addHours(new Date(cliente.data_cadastro), 3), 'dd/MM/yyyy')} menor={true} />
              <TableBodyRowStart text={cliente.titulo} menor={true} />
              <TableBodyRowStart text={cliente.paciente.nome} menor={true} />
              <TableBodyRowStart text={cliente.tecnico_responsavel.nome} menor={true} />

              <td className='tableRowCenter'>
                <div className='buttonContainer'>
                  <Button variant='outline-secondary' className='m-0 p-0 px-2' onClick={() => editFunction(cliente.id)} >Editar</Button>
                  <Button variant='outline-danger' className='m-0 p-0 px-2' onClick={() => { deleteFunction(cliente.id) }} >Remover</Button>
                </div>
              </td>
            </tr>
          )
        })}
      </tbody >
    </>
  )
}

export default TableData